import React from 'react';
import styled from 'styled-components';
import TileCard from '@components/layout/TileCard';

import {TileCardT} from "@components/layout/TileCard.type";

interface propsT {
  isAuthorized: boolean;
  cards: Array<TileCardT>;
}

const debug = false;

// display a set of active/inactive tiles
const PageTiles = (props: propsT) => {
  debug && console.log('PageTiles | props: ', props);
  const {isAuthorized, cards} = props;

  return (
      <TileCards>
        {cards.map((card, cardId) => {
          return(
            <TileCard
              key = {cardId}
              isAuthorized={isAuthorized}
              card = {card}
            />
          );
        })}
      </TileCards>
  );
};

const TileCards = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

export default PageTiles;
